import { ReactNode, createContext, useContext } from 'react';
import { DialogViewerProps } from './viewer.interface';
import { RedirectViewer } from './redirectViewer';

export interface IDialogViewContext {
  Viewer: (props: DialogViewerProps) => ReactNode | null;
}

const context = createContext<IDialogViewContext>({
  Viewer: RedirectViewer,
});

export const DialogViewContextProvider = context.Provider;

export const useDialogViewContext = () => {
  return useContext(context);
};
